import * as React from 'react';

import { CreateButton } from '@ixicare/ui';
import { Link } from 'react-router-dom';
import { SiteFloorsTable } from '../components';
import SiteStore from '../store/Site';

interface SiteFloorListContainerProps {
  site: SiteStore;
}

const SiteFloorListContainer: React.FC<SiteFloorListContainerProps> = ({ site }) => {
  return (
    <>
      <SiteFloorsTable site={site} />
      <Link to={`/sites/${site.uuid}/create`}>
        <CreateButton atBottom />
      </Link>
    </>
  );
};

export default SiteFloorListContainer;
